// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.details-item[data-v-68b03b0e] {\n  display: flex;\n  justify-content: space-between;\n  padding: 0 1.05rem;\n}\n.details-item > .rule-item[data-v-68b03b0e] {\n  height: calc(2.95rem + 3px + 0.4rem);\n  padding: 1rem 1.15rem;\n}\n.details-item > .ui-toggle[data-v-68b03b0e] {\n  margin-top: auto;\n  margin-bottom: auto;\n}\n", ""]);
// Exports
module.exports = exports;
